export default "__VITE_ASSET__Dku$iwdr__"